import React, { FC } from 'react';
import {
    ExtendedManageRenewalCells,
    ManageRenewalCells,
    SimpleManageRenewalCells
} from '../utils/renewalTableTileTypes';
import { SimpleRenewalTableTile } from './simple/SimpleRenewalTile';
import { ExtendedRenewalTableTile } from './extended/ExtendedRenewalTableTile';

type Props = SimpleManageRenewalCells | ExtendedManageRenewalCells;

export const ManageRenewalTableBody: FC<Props> = ({ type, list }) => {
    switch (type) {
        case ManageRenewalCells.Simple:
            return <SimpleRenewalsBody list={list} />;
        case ManageRenewalCells.Extended:
            return <ExtendedRenewalsBody list={list} />;
        default:
            return <tbody></tbody>;
    }
};

type SimpleRenewalsBodyProps = Omit<SimpleManageRenewalCells, 'type'>;
export const SimpleRenewalsBody: FC<SimpleRenewalsBodyProps> = ({ list }) => {
    return (
        <tbody className="simple">
            {list.map(entry => (
                <SimpleRenewalTableTile {...entry} key={entry.product.id} />
            ))}
        </tbody>
    );
};

type ExtendedRenewalsBodyProps = Omit<ExtendedManageRenewalCells, 'type'>;
export const ExtendedRenewalsBody: FC<ExtendedRenewalsBodyProps> = ({ list }) => {
    return (
        <tbody className="extended">
            {list.map(entry => (
                <ExtendedRenewalTableTile {...entry} key={entry.product.id} />
            ))}
        </tbody>
    );
};
